import Edit from 'components/Icons/Edit';
import BinTrash from 'components/Icons/BinTrash';

import './DailyMessage.scoped.scss';
import { useDispatch } from 'react-redux';

import { headerButtonClickedIs } from 'redux/header/header.slices';

interface Props {
  name: string;
  date: Date;
}

const DailyMessage: React.FC<Props> = ({ name }) => {
  const dispatch = useDispatch();

  return (
    <div className="container">
      <div className="wrapper">
        <h1 className="title">{name}</h1>
        <div className="icons">
          <div onClick={() => dispatch(headerButtonClickedIs('DailyMessage'))}>
            <Edit color="#6e7e97" />
          </div>
          <div>
            <BinTrash color="#6e7e97" marginLeft={6} />
          </div>
        </div>
      </div>
      <h4 className="created-at">Just created</h4>
    </div>
  );
};

export default DailyMessage;
